export const iconMap = {
    Info: { icon: 'solar:info-circle-bold', color: 'info.main', bgcolor: 'info.lighter' },
    Success: { icon: 'solar:check-circle-bold', color: 'success.main', bgcolor: 'success.lighter' },
    Warning: { icon: 'solar:danger-triangle-bold', color: 'warning.main', bgcolor: 'warning.lighter' },
    Error: { icon: 'solar:close-circle-bold', color: 'error.main', bgcolor: 'error.lighter' },
  };
  
export const getIconConfig = (type) => iconMap[type] || iconMap.Info;